// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2JPcl","notes":"Notes_notes__2yvOj","note":"Notes_note__22AE5","markdown":"Notes_markdown__gys9d"};